import React, { useEffect } from 'react'
import Button from '../components/Button'
import RadioButtonQuestion from '../components/RadioButtonQuestion'
import {questions} from '../data/json'


const TestQuestions4 = ({prevStep, nextStep, handleChange, values}) => {

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
  }, [])

  const Continue = e => {
    e.preventDefault();
    nextStep();
  }

  const GoBack = e => {
    e.preventDefault();
    prevStep(); 
  }

  return (
    <div className='__test-questions'>
      <h2>Adfærd og kultur</h2>
      <p>Adfærd er afgørende for at styrke modstandsdygtighed i virksomheden. Medarbejdernes overholdelse af procedurer inden for fx IT-sikkerhed og forretningskontinuitet er vigtig. Opbygning af en virksomhedskultur, der fremmer innovation, samarbejde, læring og tillid, er afgørende for at motivere medarbejdere til at handle hurtigt og effektivt i pressede situationer. En stærk virksomhedskultur skaber tillid og samarbejde mellem medarbejdere og ledelse, hvilket er afgørende for konstruktivt og koordineret arbejde under kriser. </p>
        <form>
          <RadioButtonQuestion isChecked={values.qst4_1} title={questions.culture.qst_1} name="qst-culture_1" value={values} onChange={handleChange('qst4_1')}/>
          <RadioButtonQuestion isChecked={values.qst4_2} title={questions.culture.qst_2} name="qst-culture_2" value={values} onChange={handleChange('qst4_2')}/>
          <RadioButtonQuestion isChecked={values.qst4_3} title={questions.culture.qst_3} name="qst-culture_3" value={values} onChange={handleChange('qst4_3')}/>
          <RadioButtonQuestion isChecked={values.qst4_4} title={questions.culture.qst_4} name="qst-culture_4" value={values} onChange={handleChange('qst4_4')}/>
          <RadioButtonQuestion isChecked={values.qst4_5} title={questions.culture.qst_5} name="qst-culture_5" value={values} onChange={handleChange('qst4_5')}/>
          <div className='__prev-next-buttons'>
            <Button buttonText='Tilbage' onClick={GoBack} />
            <Button buttonText='Næste' onClick={Continue} disabled={(values.qst4_1 !== '' && values.qst4_2 !== '' && values.qst4_3 !== '' && values.qst4_4 !== '' && values.qst4_5 !== '' ) ? false : true} />
          </div>
        </form>
    </div>

  )
}

export default TestQuestions4